import React from 'react';

import moment from 'moment';

import Table from '../../../Table';
import Pagination from '../../../Pagination';
import ActionMenu from '../../../ActionsMenu';

import sumDollarAmounts from '../../../../helpers/sumDollarAmounts';
import useInsurancesActions from './hooks/useInsurancesActions';

export default function InsurancesTable({
  loanId,
  isFetching,
  insurances,
  createInsuranceLink,
  readOnly,
  headerRight,
  refetch,
  isLender,
  pageTotal,
  currentPage,
  switchToPage,
}) {
  const cols = [
    {
      title: 'Policy Number',
      keys: ['policy_number'],
      link: createInsuranceLink,
    },
    {
      title: 'Payee',
      keys: ['doesntmatter'],
      format: (_, row) => {
        if (row.send_payment_to === 'Broker') {
          return row._broker?.name || '';
        }
        if (row.send_payment_to === 'Carrier') {
          return row._carrier?.name || '';
        }

        if (row.send_payment_to === 'Agent') {
          return row._agent?.name || '';
        }

        return '';
      },
    },
    {
      title: 'Start Date',
      keys: ['start_date'],
      format: (value) => (value ? moment(value).format('M/D/YY') : ''),
    },
    {
      title: 'End Date',
      keys: ['end_date'],
      format: (value) => (value ? moment(value).format('M/D/YY') : ''),
    },
    {
      title: 'Type',
      keys: ['type'],
    },
    {
      title: 'Payment Status',
      keys: ['status'],
      format: (value, row) => {
        const billsPaidSum = sumDollarAmounts(row.bill_id, '_paid.total');

        if (billsPaidSum === row.premium) {
          return 'paid';
        }
        return 'pending';
      },
    },
    {
      title: 'Status',
      keys: ['status'],
    },
  ];

  const actions = useInsurancesActions({
    loanId,
    insurances,
    refetch,
  });

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-6 gap-4">
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold">
          Insurances
        </h2>
        {loanId && !readOnly && (
          <div className="flex">
            <ActionMenu actions={actions} />
          </div>
        )}
      </div>

      <Table
        headerRightContent={headerRight}
        cols={cols}
        rows={insurances}
        title="Insurances"
        isFetching={isFetching}
        minHeight={565}
      />
      {isLender && (
        <Pagination
          pageTotal={pageTotal}
          switchToPage={switchToPage}
          currentPage={currentPage}
        />
      )}
    </div>
  );
}
